import React, { useCallback } from 'react'

import type { IControlProps } from 'components/controls/Field/Field.types'
import type { ISegmentedProps } from 'components/uiKit/Segmented'
import Segmented from 'components/uiKit/Segmented'

/** @deprecated use [FormKit](../../../../components/formKit/fields/index.ts) */
const FieldSegmented: React.FC<IControlProps<ISegmentedProps>> = ({
  name,
  onChange,
  defaultValue,
  value,
  fluid,
  ...rest
}) => {
  const handleChange = useCallback(
    (value: ISegmentedProps['value']) => onChange({ value, name }),
    [name, onChange],
  )

  return (
    <Segmented
      fluid={fluid}
      name={name}
      onChange={handleChange}
      {...rest}
      value={value ?? (defaultValue as string)}
    />
  )
}

export default FieldSegmented
